import { create } from 'zustand';
import api from '@/lib/api';

// ВАЖНО: в localStorage хранятся только UI-данные пользователя (имя, email, avatarUrl).
// Токен аутентификации (accessToken) хранится исключительно в httpOnly cookie —
// он недоступен из JavaScript и не попадает в localStorage никогда.

import type { ApiUser } from '@/lib/contract';

// Тип пользователя приходит из общего контракта API (lib/contract)
type User = ApiUser;

interface AuthStore {
  user: User | null;
  isLoading: boolean;
  isInitialized: boolean;
  setUser: (user: User) => void;
  clearAuth: () => void;
  isAuthenticated: () => boolean;
  initAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthStore>((set, get) => ({
  user: null,
  isLoading: true,
  isInitialized: false,

  setUser: (user) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('user', JSON.stringify(user));
    }
    set({ user });
  },

  clearAuth: () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('user');
    }
    set({ user: null, isLoading: false, isInitialized: true });
  },

  isAuthenticated: () => !!get().user,

  initAuth: async () => {
    if (get().isInitialized) return;
    if (typeof window === 'undefined') {
      set({ isLoading: false, isInitialized: true });
      return;
    }

    // Восстанавливаем user из localStorage мгновенно
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        set({ user: JSON.parse(storedUser), isLoading: false });
      } catch { /* невалидный JSON */ }
    }

    // Валидируем сессию через cookie (accessToken httpOnly)
    try {
      const res = await api.get('/users/me');
      const user = res.data.data;
      localStorage.setItem('user', JSON.stringify(user));
      set({ user, isLoading: false, isInitialized: true });
    } catch {
      get().clearAuth();
    }
  },
}));
